import React, { useMemo } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import {
  Flex,
  Table,
  Progress,
  Icon,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Box,
  Avatar,
} from "@chakra-ui/react";
import { Button, Link } from "@chakra-ui/react";
import { IoCheckmarkCircle } from "react-icons/io5";

// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import Banner from "views/admin/profile/components/Banner";
import banner from "assets/img/auth/banner.png";
import avatar from "assets/img/avatars/avatar4.png";
// Assets
import { MdCheckCircle, MdCancel, MdOutlineError } from "react-icons/md";
const ReportModal = ({
  showreportPreview,
  setShowreportPreview,
  reportPreview,
}) => {
  // Dummy data fallback
  // const dummyReport = {
  //   Provider_Name: "SARAH WILLIAMS",
  //   DESCRIPTION: "Excision, tumour, soft tissue of thigh or knee area, subcutaneous; less than 3 cm",
  //   TAX_ID: "666543210",
  //   CPT_CODE: "27327",
  //   RATE: "$351",
  //   report: {
  //     provider_name: {
  //       claim_provider_name: "SARAH WILLIAMS",
  //       contract_provider_name: "SARAH WILLIAMS",
  //       match: true,
  //     },
  //     rate: {
  //       claim_rate: "$351",
  //       contract_rate: "$351",
  //       match: true,
  //     },
  //     submit_claim_date: {
  //       contract_date: "2025-08-01",
  //       claim_date: "2025-08-10",
  //       submit_claim_time: "5",
  //       match: false,
  //     },
  //   },
  // };

  const safePreview = reportPreview || {};
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";

  function checkSuccess(data) {
    const report = data.report;
    if (!report) {
      return true;
    }
    // "border-2 border-[#FF5733]"
    for (const key in report) {
      if (
        report.hasOwnProperty(key) &&
        typeof report[key] === "object" &&
        "match" in report[key]
      ) {
        if (!report[key].match) {
          return false;
        }
      }
    }

    return true;
    // "border-2 border-[#7CFC00]"
  }

  function checkHowMuchExceding(contract_date, submit_claim_time, claim_date) {
    const oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day

    // Convert the date strings to Date objects
    const contractDateObj = new Date(contract_date);
    const claimDateObj = new Date(claim_date);

    // Calculate the difference in days
    var diffDays = Math.floor(
      (claimDateObj.getTime() - contractDateObj.getTime()) / oneDay
    );
    if (diffDays > parseInt(submit_claim_time)) {
      return `Exceeded ${diffDays - parseInt(submit_claim_time)} days`; // Return the number of days exceeding the limit
    } else {
      return "On Time"; // Return 0 if the difference is within the limit
    }
  }

  return (
    <div
      id="staticModal"
      data-modal-backdrop="static"
      tabindex="-1"
      aria-hidden="true"
      class={`${
        showreportPreview ? "" : "hidden"
      } bg-gray-100  flex flex-col fixed top-[3%] border-2 border-gray-100 rounded-lg left-[2.5%] right-[2.5%] z-50  w-[95%] h-[95%]  `}
    >
      <div className=" h-[5%] rounded-t-lg text-end   flex flex-row justify-center items-center p-2">
        <button
          onClick={() => {
            setShowreportPreview(!showreportPreview);
          }}
          type="button"
          class="text-color-text bg-transparent hover:bg-gray-200 hover:text-color-text rounded-lg text-sm p-1.5 ml-auto inline-flex items-center "
          data-modal-hide="staticModal"
        >
          <svg
            class="w-5 h-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </button>
      </div>
      <div className=" h-[95%] p-4 overflow-x-hidden overflow-y-auto ">
        <Card
          direction="column"
          w="100%"
          px="0px"
          overflowX={{ sm: "scroll", lg: "hidden" }}
        >
          {/* <Flex px="25px" justify="space-between" mb="20px" align="center">
            <Text
              color={textColor}
              fontSize="22px"
              fontWeight="700"
              lineHeight="100%"
            >
              Complex Table
            </Text>
            <Menu />
          </Flex> */}
          <Card mb={{ base: "0px", lg: "20px" }} align="center">
            {/* <Box
              bg={`url(${banner})`}
              bgSize="cover"
              borderRadius="16px"
              h="131px"
              w="100%"
            /> */}
            <Avatar
              mx="auto"
              src={avatar}
              h="87px"
              w="87px"
              mt="20px"
              border="4px solid"
              borderColor={borderColor}
            />
            <Text
              color={textColorPrimary}
              fontWeight="bold"
              fontSize="xl"
              mt="10px"
            >
              {safePreview.Provider_Name}
            </Text>
            <Text color={textColorSecondary} fontSize="sm">
              {safePreview.DESCRIPTION}
            </Text>
            <Flex w="max-content" mx="auto" mt="26px">
              <Flex mx="auto" me="60px" align="center" direction="column">
                <Text color={textColorPrimary} fontSize="2xl" fontWeight="700">
                  {safePreview.TAX_ID}
                </Text>
                <Text color={textColorSecondary} fontSize="sm" fontWeight="400">
                  TAX ID
                </Text>
              </Flex>
              <Flex mx="auto" me="60px" align="center" direction="column">
                <Text color={textColorPrimary} fontSize="2xl" fontWeight="700">
                  {safePreview.CPT_CODE}
                </Text>
                <Text color={textColorSecondary} fontSize="sm" fontWeight="400">
                  CPT CODE
                </Text>
              </Flex>
              <Flex mx="auto" align="center" direction="column">
                <Text color={textColorPrimary} fontSize="2xl" fontWeight="700">
                  {safePreview.RATE}
                </Text>
                <Text color={textColorSecondary} fontSize="sm" fontWeight="400">
                  RATE
                </Text>
              </Flex>
            </Flex>
          </Card>
          <Table variant="simple" color="gray.500" marginX="60px">
            <Thead>
              <Tr>
                <Th
                  pe="10px"
                  borderColor={borderColor}
                  fontSize="sm"
                  fontWeight="700"
                >
                  CLAIM'S PROVIDER NAME
                </Th>
                <Th
                  pe="10px"
                  borderColor={borderColor}
                  fontSize="sm"
                  fontWeight="700"
                >
                  CONTRACT PROVIDER NAME
                </Th>
                <Th
                  pe="10px"
                  borderColor={borderColor}
                  fontSize="sm"
                  fontWeight="700"
                >
                  SUCCESS
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>
                  <Text fontSize="sm" fontWeight="700">
                    {safePreview.report?.provider_name?.claim_provider_name ||
                      "-"}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" fontWeight="700">
                    {safePreview.report?.provider_name
                      ?.contract_provider_name || "-"}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" fontWeight="700">
                    {safePreview.report?.provider_name?.match === true ? (
                      <Flex align="center">
                        <Icon
                          w="24px"
                          h="24px"
                          me="5px"
                          color="green.500"
                          as={MdCheckCircle}
                        />
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          Approved
                        </Text>
                      </Flex>
                    ) : (
                      <Flex align="center">
                        <Icon
                          w="24px"
                          h="24px"
                          me="5px"
                          color="red.500"
                          as={MdCancel}
                        />
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          Rejected
                        </Text>
                      </Flex>
                    )}
                  </Text>
                </Td>
              </Tr>
            </Tbody>
            <Thead>
              <Tr>
                <Th
                  pe="10px"
                  borderColor={borderColor}
                  fontSize="sm"
                  fontWeight="700"
                >
                  CLAIM'S RATE
                </Th>
                <Th
                  pe="10px"
                  borderColor={borderColor}
                  fontSize="sm"
                  fontWeight="700"
                >
                  CONTRACT RATE
                </Th>
                <Th
                  pe="10px"
                  borderColor={borderColor}
                  fontSize="sm"
                  fontWeight="700"
                >
                  SUCCESS
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>
                  <Text fontSize="sm" fontWeight="700">
                    {safePreview.report?.rate?.claim_rate || "-"}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" fontWeight="700">
                    {safePreview.report?.rate?.contract_rate || "-"}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" fontWeight="700">
                    {safePreview.report?.rate?.match === true ? (
                      <Flex align="center">
                        <Icon
                          w="24px"
                          h="24px"
                          me="5px"
                          color="green.500"
                          as={MdCheckCircle}
                        />
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          Approved
                        </Text>
                      </Flex>
                    ) : (
                      <Flex align="center">
                        <Icon
                          w="24px"
                          h="24px"
                          me="5px"
                          color="red.500"
                          as={MdCancel}
                        />
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          Rejected
                        </Text>
                      </Flex>
                    )}
                  </Text>
                </Td>
              </Tr>
            </Tbody>
            <Thead>
              <Tr>
                <Th
                  pe="10px"
                  borderColor={borderColor}
                  fontSize="sm"
                  fontWeight="700"
                >
                  SUBMISSION DATE
                </Th>
                <Th
                  pe="10px"
                  borderColor={borderColor}
                  fontSize="sm"
                  fontWeight="700"
                >
                  DATE OF SERVICE
                </Th>
                <Th
                  pe="10px"
                  borderColor={borderColor}
                  fontSize="sm"
                  fontWeight="700"
                >
                  SUCCESS
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>
                  <Text fontSize="sm" fontWeight="700"></Text>
                </Td>
                <Td>
                  <Text fontSize="sm" fontWeight="700">
                    {safePreview.report?.submit_claim_date?.contract_date ||
                      "-"}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" fontWeight="700"></Text>
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <Text fontSize="sm" fontWeight="700">
                    {safePreview.report?.submit_claim_date?.claim_date || "-"}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" fontWeight="700">
                    Duration :
                    {safePreview.report?.submit_claim_date?.submit_claim_time ||
                      "-"}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" fontWeight="700">
                    {safePreview.report?.submit_claim_date?.match === true ? (
                      <Flex align="center">
                        <Icon
                          w="24px"
                          h="24px"
                          me="5px"
                          color="green.500"
                          as={MdCheckCircle}
                        />
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          Approved
                        </Text>
                      </Flex>
                    ) : (
                      <Flex align="center">
                        <Icon
                          w="24px"
                          h="24px"
                          me="5px"
                          color="red.500"
                          as={MdCancel}
                        />
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          Rejected
                        </Text>
                      </Flex>
                    )}
                  </Text>
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <Text fontSize="sm" fontWeight="700"></Text>
                </Td>
                <Td>
                  <Text fontSize="sm" fontWeight="700">
                    {checkHowMuchExceding(
                      safePreview.report?.submit_claim_date?.contract_date ||
                        "2025-08-01",
                      safePreview.report?.submit_claim_date
                        ?.submit_claim_time || "5",
                      safePreview.report?.submit_claim_date?.claim_date ||
                        "2025-08-10"
                    )}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" fontWeight="700"></Text>
                </Td>
              </Tr>
            </Tbody>
          </Table>
          <Flex align="center" marginLeft="80px" marginY="30px">
            {checkSuccess(safePreview) === true ? (
              <>
                <Icon
                  w="24px"
                  h="24px"
                  me="5px"
                  color="green.500"
                  as={MdCheckCircle}
                />
                <Text color="green.500" fontSize="lg" fontWeight="700">
                  PASS
                </Text>
              </>
            ) : (
              <>
                <Icon
                  w="24px"
                  h="24px"
                  me="5px"
                  color="red.500"
                  as={MdCheckCircle}
                />
                <Text color="red.500" fontSize="lg" fontWeight="700">
                  FAIL
                </Text>
              </>
            )}
          </Flex>
        </Card>
        {/* <div className="h-[100%] w-full">
          <div className="App">
            <div className="all-page-container">
              <AllPages pdf={filePreview} />
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default ReportModal;
